import { useAuthContext } from '../../../../context/auth.context'
import { useRoleSysNotify } from '../../../../role/hook/role-sys'

export const READ_ONLY_ROLE = 'You can view notifications but not change them. Replaying, resending, parking, test sends and push credentials need more SYS_NOTIFY permissions.'
export const READ_ONLY_IMPERSONATING = "You're signed in as someone else, so notifications can be viewed but not changed. End the impersonation to make changes."

// Who may do what in the staff Notifications section (C-6 section 4):
// read every view; update replays, resends, parks, drains, test sends and
// credential tests; create adds, activates and rotates a push credential;
// delete disables one. Every write is refused while impersonating (403
// notify.not_while_impersonating), so the UI offers none then.
export const useNotifyOpsAccess = () => {
  const { state } = useAuthContext()
  const role = useRoleSysNotify()
  const impersonating = Boolean(state && state.jwtClaims && state.jwtClaims.impersonationEndsAt)
  const can = flag => Boolean(role[flag]) && !impersonating
  const canUpdate = can('accessUpdate')
  const canCreate = can('accessCreate')
  const canDelete = can('accessDelete')
  const reason = impersonating ? READ_ONLY_IMPERSONATING : canUpdate ? null : READ_ONLY_ROLE
  return { canRead: Boolean(role.accessRead), canUpdate, canCreate, canDelete, impersonating, reason }
}
